import { forwardRef } from "react";
import { Dialog, type DialogHandle } from "../app/components/ui/Dialog";
import {
  FONT_OPTIONS,
  THEME_OPTIONS,
  useThemeStore,
  type FontId,
  type LanguageMode,
} from "../app/stores/themeStore";
import styles from "./SettingsDialog.module.css";

export const SettingsDialog = forwardRef<DialogHandle>(
  function SettingsDialog(_props, ref) {
    const themeId = useThemeStore((s) => s.themeId);
    const fontId = useThemeStore((s) => s.fontId);
    const languageMode = useThemeStore((s) => s.languageMode);
    const lintingEnabled = useThemeStore((s) => s.lintingEnabled);
    const setThemeId = useThemeStore((s) => s.setThemeId);
    const setFontId = useThemeStore((s) => s.setFontId);
    const setLanguageMode = useThemeStore((s) => s.setLanguageMode);
    const setLintingEnabled = useThemeStore((s) => s.setLintingEnabled);

    return (
      <Dialog ref={ref} title="Settings">
        <fieldset className={styles.section}>
          <legend>Theme</legend>
          <div className={styles.options}>
            {THEME_OPTIONS.map((theme) => (
              <label key={theme.id} className={styles.option}>
                <input
                  type="radio"
                  name="karel-theme"
                  checked={themeId === theme.id}
                  onChange={() => setThemeId(theme.id)}
                />
                <span>{theme.label}</span>
              </label>
            ))}
          </div>
        </fieldset>

        <fieldset className={styles.section}>
          <legend>Font</legend>
          <div className={styles.options}>
            {FONT_OPTIONS.map((font) => (
              <label key={font.id} className={styles.option}>
                <input
                  type="radio"
                  name="karel-font"
                  checked={fontId === font.id}
                  onChange={() => setFontId(font.id as FontId)}
                />
                <span>{font.label}</span>
              </label>
            ))}
          </div>
        </fieldset>

        <fieldset className={styles.section}>
          <legend>Editor language</legend>
          <div className={styles.options}>
            {(
              [
                { id: "python", label: "Python" },
                { id: "js", label: "JavaScript" },
              ] as { id: LanguageMode; label: string }[]
            ).map((mode) => (
              <label key={mode.id} className={styles.option}>
                <input
                  type="radio"
                  name="karel-language"
                  checked={languageMode === mode.id}
                  onChange={() => setLanguageMode(mode.id)}
                />
                <span>{mode.label}</span>
              </label>
            ))}
          </div>
        </fieldset>

        <fieldset className={styles.section}>
          <legend>Linting</legend>
          <label className={styles.option}>
            <input
              type="checkbox"
              checked={lintingEnabled}
              onChange={(e) => setLintingEnabled(e.target.checked)}
            />
            <span>Show code diagnostics</span>
          </label>
        </fieldset>
      </Dialog>
    );
  },
);
